import axios from "axios";
import { Config } from "../config/Config";
import firebase from "../utilities/Firebase";


/**
 * 認証サービス
 */
export const AuthService = () => {
    /**
     * 認証
     * @param rawId 暗号化された認証情報
     * @returns 認証結果
     */
    const authentication = async (user: string, isHash: boolean) => {
        const response = await axios.post(`${Config.backendBaseUrl}/api/authentication/auth-user`,
            { user, isHash },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            });

        if (response.status === 200) {
            // 認証に成功した場合、Firebaseにサインインする
            await firebase.auth().signInWithCustomToken(response.data.apiToken);
        }

        return response.data;
    };

    return { authentication };
};
